import { computed } from 'vue'
import { storeToRefs } from 'pinia'

/* Bl */
import usePresets from '@/composables/data/usePresets'

/* Stores */
import { useCompanyStore } from '@/stores/companyStore'
import { PERSONAL_SETTINGS_MAPPING, PERSONAL_SETTINGS_TO_PRESET_CODE } from '@/config/personalSettingsConfig'

export default function usePersonalCompanySettingsManager() {
	const companyStore = useCompanyStore()
	const {
		personalCompanySettings,
		personalCompanySettingByKey,
	} = storeToRefs(companyStore)
	const {
		setAllPersonalCompanySettings,
		setPersonalCompanySettings,
		setIsLoadingAllPersonalCompanySettingsStatus,
		setLoadingPersonalCompanySettings,
	} = companyStore

	const {
		getMultiplePresets,
		createOrUpdatePreset,
	} = usePresets(/* PERSONAL_SETTINGS_TO_PRESET_CODE[PERSONAL_SETTINGS_MAPPING.START_DAY] */'', {}, [])

	const DEFAULT_PERSONAL_COMPANY_SETTINGS = {
		[PERSONAL_SETTINGS_MAPPING.START_DAY]: 0, // time of start day in seconds
		[PERSONAL_SETTINGS_MAPPING.SINGLE_TEST]: 'singleTest',
	}

	const getAllPersonalCompanySettings = () => {
		setIsLoadingAllPersonalCompanySettingsStatus(true)
		getMultiplePresets({
			codes: Object.values(PERSONAL_SETTINGS_TO_PRESET_CODE),
		})
			.then((res) => {
				// console.log('getAllPersonalCompanySettings', res)
				const settings = {
					...DEFAULT_PERSONAL_COMPANY_SETTINGS,
				}

				const startDaysPresets = res.filter((preset) => (preset.code === PERSONAL_SETTINGS_TO_PRESET_CODE[PERSONAL_SETTINGS_MAPPING.START_DAY]))
				if (startDaysPresets.length) {
					settings[PERSONAL_SETTINGS_MAPPING.START_DAY] = startDaysPresets[0].config
				}

				setAllPersonalCompanySettings(settings)
				setIsLoadingAllPersonalCompanySettingsStatus(false)
			})
	}

	const updateStartDaySetting = (setting) => {
		return new Promise((resolve) => {
			setLoadingPersonalCompanySettings(PERSONAL_SETTINGS_MAPPING.START_DAY, true)
			createOrUpdatePreset(PERSONAL_SETTINGS_TO_PRESET_CODE[PERSONAL_SETTINGS_MAPPING.START_DAY], {
				name: 'Start day',
				config: setting,
			})
				.then((res) => {
					// console.log('updateStartDaySetting', res.config)
					setPersonalCompanySettings(PERSONAL_SETTINGS_MAPPING.START_DAY, res.config)
					setLoadingPersonalCompanySettings(PERSONAL_SETTINGS_MAPPING.START_DAY, false)
					resolve(res)
				})
		})
	}

	// выводим все настройки компании
	const personalCompanySettingStartDay = computed(() => {
		return personalCompanySettingByKey.value(PERSONAL_SETTINGS_MAPPING.START_DAY) ?? DEFAULT_PERSONAL_COMPANY_SETTINGS[PERSONAL_SETTINGS_MAPPING.START_DAY]
	})

	return {
		personalCompanySettings,
		setAllPersonalCompanySettings,
		getAllPersonalCompanySettings,
		updateStartDaySetting,

		personalCompanySettingStartDay,
	}
}
